export default "/images/vendor/@coreui/icons/svg/flag/cif-rs.svg?00887f6f998f774775ee1f901abd68cb";